<template>
    <div>
        <con-tab ></con-tab>
        <need-nei ></need-nei>
    </div>
</template>

<script>

    import ConTab from "../../components/common/ConTab";
    import NeedNei from "./base/Sucessresult";
    export default {
        name: "Sucessresult",
        components:{
            ConTab,
            NeedNei,
        }
    }
</script>

<style scoped>

</style>